// Add this new function
export const convertDateToMillisecondsString = (timestamp) => {
  const date = new Date(timestamp);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}.${date.getMilliseconds().toString().padStart(3, '0')}`;
}

export function convertDateToString(dateEpoch, withSeconds = false) {
  let formattedDate = "";

  // TODO : convert epoch date to string in "yyyy/MM/dd HH:MM" format
  if (dateEpoch === undefined || dateEpoch === 0 || isNaN(dateEpoch))
    return ""

  const date = new Date(dateEpoch * 1000);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  if (withSeconds)
    formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  else
    formattedDate = `${year}/${month}/${day} ${hours}:${minutes}`;

  return formattedDate;
}

export function convertDateToStringMobile(dateEpoch) {
  let formattedDate = "";

  // TODO : convert epoch date to string in "yyyy/MM/dd HH:MM" format
  if (dateEpoch === undefined || dateEpoch === 0 || isNaN(dateEpoch))
    return ""

  const date = new Date(dateEpoch);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  formattedDate = `${month}/${day} ${hours}:${minutes}:${seconds}`;

  return formattedDate;
}

export function convertDateToHourString(dateEpoch, withMilliseconds = false) {
  let formattedDate = "";

  // TODO : convert epoch date to string in "yyyy/MM/dd HH:MM" format
  if (dateEpoch === undefined || dateEpoch === 0 || isNaN(dateEpoch))
    return ""

  const date = new Date(dateEpoch * 1000);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  const milliseconds = ("00" + date.getMilliseconds()).slice(-3);
  if (withMilliseconds)
    formattedDate = `${hours}:${minutes}:${seconds}.${milliseconds}`;
  else
    formattedDate = `${hours}:${minutes}:${seconds}`;

  return formattedDate;
}

export function convertMillisToString(millis, withMilliseconds = false) {
  let formattedDate = "";

  // TODO : convert epoch date to string in "yyyy/MM/dd HH:MM" format
  if (millis === undefined || isNaN(millis))
    return ""

  const minutes = ("0" + ((millis / 60 / 1000) % 60).toFixed(0)).slice(-2);
  const seconds = ("0" + ((millis / 1000) %60).toFixed(0)).slice(-2);
  const milliseconds = ("00" + (millis % 1000).toFixed(0)).slice(-3);
  if (withMilliseconds)
    formattedDate = `${minutes}:${seconds}.${milliseconds}`;
  else
    formattedDate = `${minutes}:${seconds}`;

  return formattedDate;
}

export const sign = (n) => {
  return (n < 0 ? "" : "+") + n;
}

export const convertDurationToString = (duration) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.floor(duration % 60);
  const durationString = ((hours > 0) ? `${hours}h` : "") + ((minutes > 0) ? `${minutes}m` : "") + `${seconds.toString().padStart(2, '0')}s`;
  return durationString;
}

export const convertDurationMillisToString = (duration) => {
  const hours = Math.floor(duration / (3600 * 1000));
  const minutes = Math.floor((duration % (3600 * 1000)) / (60 * 1000));
  const seconds = Math.floor((duration % (60 * 1000)) / 1000);
  const milliseconds = ("00" + (duration % 1000)).slice(-3);

  const durationString =
    (hours > 0 ? `${hours}:` : "") +
    (minutes > 0 ? `${minutes}:` : "") +
    `${seconds.toString().padStart(2, '0')}.` +
    `${milliseconds}`;

  return durationString.trim();
}

export function convertTripDistanceToString(tripDistance) {
  let distanceInMeters = tripDistance * 10;
  if (distanceInMeters >= 1000)
    return (distanceInMeters / 1000).toFixed(2) + " km";
  else
    return (distanceInMeters).toFixed(0) + " m";
}

export function hexToRgba(hex, alpha = 1) {
  const [r, g, b] = hex.match(/\w\w/g).map((pair) => parseInt(pair, 16));
  return `rgba(${r},${g},${b},${alpha})`;
}


export const getFormattedTimeDiff = (currentMarker2Coordinates) => {
  if (currentMarker2Coordinates.length > 2) {
    const timeDiff = currentMarker2Coordinates[2];
    const absTimeDiff = Math.abs(timeDiff); // Get the absolute value of the time difference
    const seconds = Math.floor(absTimeDiff / 1000);
    const millis = absTimeDiff % 1000;

    const sign = timeDiff < 0 ? '-' : '+'; // Determine the sign based on whether the time difference is negative

    return `${sign}${seconds}.${millis.toString().padStart(3, '0')} s`;
  } else {
    return "0 s";
  }
};
